package one.healthium.domain.common

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
enum class ImageMode {
    @SerialName("fit")
    Fit,

    @SerialName("aspect_fill")
    Crop,
}